import VideoPlayer from "../VideoPlayer";


const STUDY_CARDS = [
  {
    title: "Cryotherapy for Wrinkle-Free Skin",
    body:
      "Hyperbaric gaseous cryotherapy utilizes high pressurized gas resulting in the reduced tissue temperature from 4 to 1 degree Celsius in about 30 seconds. This cold decreases nerve conduction velocity and stabilizes the membranes of facial nerve branches, which supply various facial muscles — resulting in the relaxation of these muscles, therefore helping to achieve wrinkle-free skin without neurotoxins. Thus, regular cryotherapy sessions can help achieve smooth and beautiful skin.",
  },
  {
    title: "Dark Circles & Pore Size Reduction",
    body:
      "Cryotherapy directly affects collagen, which is the principal component of the extracellular matrix in the dermis. Gaseous cryotherapy regulates collagen production that revives the skin by giving it its elastic tendencies and helps achieve younger and smoother skin by reducing pore size. It causes desquamation of the rugged superficial skin cells while promoting the growth of new cells — achieving fresher and younger-looking skin. Moreover, cold-induced reflex vasodilation enhances blood flow and nutrients to the skin, removing dark circles.",
  },
  {
    title: "Cryotherapy Prevents Skin Aging",
    body:
      "Oxidative stress induced by the reactive oxygen species (ROS) produced in the body constantly damages skin and causes skin aging characterized by wrinkling and hardening of the skin due to loss of elastic fibers. The ROS produced due to photo-induced inflammation (UV rays) cause peroxidation of lipids in the membranes of skin cells and damage various layers of the epidermis. Cryotherapy helps prevent these skin changes and aging by improving the delivery of antioxidants to the skin. Gaseous cryotherapy stimulates the body's immune response, boosting antioxidant production, and cold-induced vasoconstriction causes reflex vasodilation, improving blood flow to the site. Because cryotherapy boosts the production and delivery of antioxidants to the skin, it reverses the skin damage caused by the sun.",
  },
  {
    title: "Scar Reduction After Wounds & Injuries",
    body:
      "One common complication of many injuries and wounds is a permanent skin scar that disrupts beauty and compromises aesthetics. Cryotherapy can play an essential role in promoting wound healing with minimal scarring post-injury. A rapid drop in temperature causes vasoconstriction followed by reflex vasodilation. Dilation of cutaneous vessels improves blood flow to the injured site that supplies nutrients for healing and repair. Early healing and regeneration can prevent the deposition of fibers (fibrosis) and scarring. In addition, cryotherapy enhances immune responses, which activate tissue macrophages and other phagocytes — resulting in the removal of destroyed cells, clearing cellular debris while promoting tissue repair and healing.",
  },
];

export const ClinicalStudiesSection = () => {
  return (
    <section id="clinical-studies" className="py-24 bg-[#0a0318] relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-amber-500/10 border border-amber-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-amber-300 font-medium">Research-Backed Results</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-amber-400">Clinical</span> <span className="text-white">Studies</span>
            </h2>
            <p className="text-white/70 text-lg max-w-3xl mx-auto">
              Use of Subzero Gaseous Cryotherapy for Aesthetic Benefits
            </p>
          </div>

          <div className="mb-10">
            <div className="text-center mb-6">
              <h3 className="text-2xl md:text-3xl font-bold text-white">
                See <span className="text-amber-400">How It Works</span>
              </h3>
              <p className="text-white/60 text-sm mt-2">
                The science behind targeted cold therapy — visualized.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <VideoPlayer
                mp4Url="https://customer-assets.emergentagent.com/job_03ef429b-7848-4d02-a509-8f2521b3aecf/artifacts/ii7679w9_How%20Cryolipolysis%20Works.mp4"
                title="How Cryolipolysis Works"
                description="Targeted fat-cell freezing, safely and non-invasively."
              />
              <VideoPlayer
                mp4Url="https://customer-assets.emergentagent.com/job_03ef429b-7848-4d02-a509-8f2521b3aecf/artifacts/0067sko0_Cryo%20Facial%20Explained%20America%20Cryo.mp4"
                title="Cryo Facial Explained"
                description="How a SubZero cryo facial tightens skin and reduces wrinkles."
              />
            </div>
          </div>

          <div className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8 mb-8">
            <p className="text-white/70 leading-relaxed">
              Young and good-looking skin is the primary goal of various aesthetics products and procedures that are
              common nowadays. People are storming towards such treatments to prevent age-related skin changes and
              achieving smooth and tight skin and reduce subcutaneous fat that makes them look young and beautiful.
              While different injections and invasive procedures (such as fillers) are available, a relatively new and
              efficient therapy has become popular because of its outstanding aesthetic benefits. Hyperbaric gaseous
              cryotherapy is a safe and non-invasive procedure utilizing high pressurized (under 50 bar pressure)
              carbonic gas. The result is a rapid drop in tissue temperature at the treatment area. Because of its
              aesthetic benefits, gaseous cryotherapy is now used for{" "}
              <span className="text-amber-400 font-semibold">body contouring (cool-sculpting)</span> and{" "}
              <span className="text-amber-400 font-semibold">loss of subcutaneous fat</span> for a toned and younger
              skin (cryo-lipolysis).
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {STUDY_CARDS.map((card) => (
              <div key={card.title} className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8">
                <h3 className="text-xl font-bold text-amber-400 mb-4">{card.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{card.body}</p>
              </div>
            ))}
          </div>

          <div className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8 mb-8">
            <h3 className="text-xl font-bold text-amber-400 mb-4">Body Contouring & Fat Reduction (Cryolipolysis)</h3>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Body contouring and weight loss have been the primary goals of all the aesthetic procedures introduced in
              the market. Cryotherapy is an effective way of attaining fat reduction. It is a non-invasive and
              convenient way of weight loss compared to liposuction and other similar techniques that involve invasive
              procedures. Gaseous cryotherapy helps achieve weight loss through a process called{" "}
              <span className="text-amber-400 font-semibold">cryolipolysis</span>.
            </p>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Cryolipolysis means the destruction of fat cells through cold, becoming popular after a case of
              &ldquo;popsicle panniculitis&rdquo; — involving fat reduction in the cheek of an infant following the
              ingestion of a popsicle. Gaseous cryotherapy aims at the application of cold temperature to areas of high
              adipose tissues. The rapid drop in temperature is highly damaging to subcutaneous fat. The cold destroys
              the fatty tissues while sparing other cells and tissues due to the increased susceptibility of adipose
              cells to cold-induced damages.
            </p>
            <p className="text-white/70 text-sm leading-relaxed">
              The destruction of adipose cells initiates an inflammatory response. This response stimulates leukocytes,
              such as neutrophils and other phagocytes, clearing cellular debris. Regular sessions of the therapy can
              help reduce abdominal fat. Additional treatment areas are{" "}
              <span className="text-amber-400 font-semibold">flanks, inner thighs, hip, and sub-buttock regions</span>.
              Gaseous cryotherapy remains a safe, non-surgical, and convenient method of fat reduction and weight loss.
            </p>
          </div>

          <div className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8">
            <h3 className="text-xl font-bold text-amber-400 mb-4">Clinical Data in Support of Aesthetic Benefits</h3>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Cryotherapy cools the skin more effectively and rapidly than traditional ice pack treatments. The effect
              was observed by comparing ice packs to applying highly pressurized (below 50 bar pressure) CO2 at low
              temperature (-78 degrees Celsius). The application of cryotherapy achieved a rapid reduction of skin
              temperature on the dorsal side of the hand and the palmar aspect of the contralateral hand.
            </p>
            <p className="text-white/70 text-sm leading-relaxed">
              Cryotherapy has been shown to{" "}
              <span className="text-amber-400 font-semibold">improve systemic microcirculation</span>, enhancing the
              oxygenation of the skin and promoting healthier skin.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
